import React, { useState } from "react";
import { texts } from "../lib/constants";

function QuizGroupsQuestions({
  language,
  userData,
  questions,
  setCurrentQuestionsGroup,
  setUserTypeForm,
  isActiveQuestionsGroups,
  setIsActiveQuestionsGroups,
  setIsActiveVotingGroups,
  isMobile,
  isTablet,
  setShowMenu
}) {
  const [isActive, setisActive] = useState();
  const updateCurrentGroup = (groupNumber) => {
    setCurrentQuestionsGroup(groupNumber);
    setIsActiveQuestionsGroups(true);
    setIsActiveVotingGroups();
    setisActive(groupNumber);
  };

  return (
    <div>
      {questions?.map((question, key) => {
        let groupQuestionsNumber = Math.floor(key / 2 + 1);
        let questionNumber = key + 1;
        const customKeys = ["OII", "IDI", "ITI", "ICI", "BII", "IPI"];
        const questionKey = customKeys[key / 2];
        if (key % 2 === 0 && questionNumber < 40) {
          return (
            <div
              onClick={() => {
                if (
                  userData && userData?.questions
                    ? userData?.questions[
                        groupQuestionsNumber < 10
                          ? "G0" + groupQuestionsNumber
                          : "G" + groupQuestionsNumber
                      ]?.done !== true
                    : true
                ) {
                  updateCurrentGroup(key / 2 + 1);
                  setUserTypeForm("questions");
                  window.scrollTo(0, 0);
                  setShowMenu(false);
                }
              }}
              className={
                groupQuestionsNumber === isActive && isActiveQuestionsGroups
                  ? "questions questions-selected text-body-2"
                  : "questions text-body-2"
              }
              key={key}
            >
              <div style={{ marginRight: isMobile || isTablet ? "12px" : 0 }}>
                {texts[language].questionGroupText} {questionKey}{" "}
              </div>
              {userData && userData?.questions ? (
                userData?.questions[
                  groupQuestionsNumber < 10
                    ? "G0" + groupQuestionsNumber
                    : "G" + groupQuestionsNumber
                ]?.done === true ? (
                  <div>
                    <img
                      style={{ paddingTop: "12px" }}
                      alt="check"
                      src="/assets/img/icon-success.png"
                    ></img>
                  </div>
                ) : userData?.questions[
                    groupQuestionsNumber < 10
                      ? "G0" + groupQuestionsNumber
                      : "G" + groupQuestionsNumber
                  ] ? (
                  <span>
                    {
                      Object.keys(
                        userData?.questions[
                          groupQuestionsNumber < 10
                            ? "G0" + groupQuestionsNumber
                            : "G" + groupQuestionsNumber
                        ]
                      ).length
                    }{" "}
                    <span> {texts[language].of} 2</span>
                  </span>
                ) : (
                  <div className="empty-div"></div>
                )
              ) : (
                <div className="empty-div"></div>
              )}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export default QuizGroupsQuestions;
